export default [
  {
    id: 1,
    img: "./pic-glry/btc-parachute.jpeg",
    description: "Rise and shine",
  },
  {
    id: 2,
    img: "./btc-nodes.jpeg",
    description: "Engineer a better future",
  },
  {
    id: 3,
    img: "./btc-bike.jpeg",
    description: "Ride or die",
  },
  {
    id: 4,
    img: "./btc-bull.jpeg",
    description: "A new bull is coming to Wallstreet",
  },
  {
    id: 5,
    img: "./btc-time.jpeg",
    description: "Don't be late to Bitcoin",
  },
  {
    id: 6,
    img: "./pic-glry/btc-babe.jpeg",
    description: "Behold Bitcoin",
  },
  {
    id: 7,
    img: "./pic-glry/btc-white.jpeg",
    description: "BTC is classic",
  },
  {
    id: 8,
    img: "./pic-glry/btc-stacks.jpeg",
    description: "Stay humble and stack sats",
  },
  {
    id: 9,
    img: "./pic-glry/btc-golden.jpeg",
    description: "Bitcoin is Power",
  },
  {
    id: 10,
    img: "./pic-glry/saylors2.jpg",
    description: "Bitcoin for the kids",
  },
  {
    id: 11,
    img: "./pic-glry/saylors.jpg",
    description: "Gold is Physical, Fiat is political, Bitcoin is Mathematical",
  },
  {
    id: 12,
    img: "./pic-glry/20231012_220921.jpg",
    description: "Bitcoin is Freedom",
  },
  {
    id: 13,
    img: "./pic-glry/20231012_221023.jpg",
    description: "Bitcoin is Hope",
  },
  {
    id: 14,
    img: "./pic-glry/20231012_221031.jpg",
    description: "Bitcoin is Faster",
  },
  {
    id: 15,
    img: "./pic-glry/20231012_221044.jpg",
    description: "Find Bitcoin",
  },
  {
    id: 16,
    img: "./pic-glry/20231012_221054.jpg",
    description: "Bitcoin is Inevitable",
  },
  {
    id: 17,
    img: "./pic-glry/20231012_221105.jpg",
    description: "Bitcoin upgrades the World",
  },
  {
    id: 18,
    img: "./pic-glry/20231012_221115.jpg",
    description: "Bitcoin is the Ruler",
  },
  {
    id: 19,
    img: "./pic-glry/20231012_221121.jpg",
    description: "Bitcoin to Glory",
  },
  {
    id: 20,
    img: "./pic-glry/20231012_221133.jpg",
    description: "Bitcoin to  Bright Future",
  },
  {
    id: 21,
    img: "./pic-glry/20231012_221141.jpg",
    description: "Bitcoin is Grace",
  },
  {
    id: 22,
    img: "./pic-glry/20231012_221210.jpg",
    description: "BTC on the Brink",
  },
  {
    id: 23,
    img: "./pic-glry/20231012_221218.jpg",
    description: "BTC for Eternity",
  },
  {
    id: 24,
    img: "./pic-glry/20231012_221237.jpg",
    description: "Bitcoin enriches Life",
  },
  {
    id: 25,
    img: "./pic-glry/20231012_221302.jpg",
    description: "Bitcoin is the Jewel in the Crown",
  },
  {
    id: 26,
    img: "./pic-glry/20231012_221338.jpg",
    description: "BTC is Power",
  },
  {
    id: 27,
    img: "./pic-glry/20231012_221347.jpg",
    description: "Bitcoin is the Future",
  },
  {
    id: 28,
    img: "./pic-glry/20231012_221400.jpg",
    description: "You'll never walk alone",
  },
  {
    id: 29,
    img: "./pic-glry/20231012_221436.jpg",
    description: "Bitcoin is Everywhere",
  },
  {
    id: 30,
    img: "./pic-glry/20231012_221517.jpg",
    description: "Bitcoin makes you stronger",
  },
  {
    id: 31,
    img: "./pic-glry/20231012_221530.jpg",
    description: "All aboard the the Bitcoin train",
  },
  {
    id: 32,
    img: "./pic-glry/20231012_221540.jpg",
    description: "Bitcoin is opportunity",
  },
  {
    id: 33,
    img: "./20231012_221601.jpg",
    description: "Bitcoin is Immortal",
  },
  {
    id: 34,
    img: "./20231012_221612.jpg",
    description: "Bitcoin is Art",
  },
  {
    id: 35,
    img: "./20231012_221620.jpg",
    description: "Bitcoin is the Orange Queen",
  },
  {
    id: 36,
    img: "./pic-glry/20231012_221740.jpg",
    description: "Bitcoin is Transcedent",
  },
  {
    id: 37,
    img: "./pic-glry/20231012_221749.jpg",
    description: "Wake up and Bitcoin",
  },
  {
    id: 38,
    img: "./pic-glry/btc2.jpg",
    description: "",
  },
  {
    id: 39,
    img: "./pic-glry/btc3.jpg",
    description: "",
  },
  {
    id: 40,
    img: "./pic-glry/btc1.jpg",
    description: "",
  },
];
